// SVG ANIMATION

!function(t, n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof __SVGATOR_DEFINE__&&__SVGATOR_DEFINE__.amd?__SVGATOR_DEFINE__(n):((t="undefined"!=typeof globalThis?globalThis:t||self).__SVGATOR_PLAYER__=t.__SVGATOR_PLAYER__||{},t.__SVGATOR_PLAYER__["5c7f360c"]=n())}(this,(function(){"use strict";function t(t, n){var e=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(t,n).enumerable}))),e.push.apply(e,r)}return e}function n(n){for(var e=1; e<arguments.length; e++){var r=null!=arguments[e]?arguments[e]:{};e%2?t(Object(r),!0).forEach((function(t){o(n,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(n,Object.getOwnPropertyDescriptors(r)):t(Object(r)).forEach((function(t){Object.defineProperty(n,t,Object.getOwnPropertyDescriptor(r,t))}))}return n}function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t, n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}function i(t, n){for(var e=0; e<n.length; e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function u(t, n, e){return n&&i(t.prototype,n),e&&i(t,e),t}function o(t, n, e){return n in t?Object.defineProperty(t,n,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[n]=e,t}function a(t){return(a=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function l(t, n){return(l=Object.setPrototypeOf||function(t, n){return t.__proto__=n,t})(t,n)}function s(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}function f(t, n, e){return(f=s()?Reflect.construct:function(t, n, e){var r=[null];r.push.apply(r,n);var i=new(Function.bind.apply(t,r));return e&&l(i,e.prototype),i}).apply(null,arguments)}function c(t, n){if(n&&("object"==typeof n||"function"==typeof n))return n;if(void 0!==n)throw new TypeError("Derived constructors may only return object or undefined");return function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t)}function h(t, n, e){return(h="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t, n, e){var r=function(t, n){for(; !Object.prototype.hasOwnProperty.call(t,n)&&null!==(t=a(t)););return t}(t,n);if(r){var i=Object.getOwnPropertyDescriptor(r,n);return i.get?i.get.call(e):i.value}})(t,n,e||t)}function v(t){return function(t){if(Array.isArray(t))return y(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t, n){if(!t)return;if("string"==typeof t)return y(t,n);var e=Object.prototype.toString.call(t).slice(8,-1);"Object"===e&&t.constructor&&(e=t.constructor.name);if("Map"===e||"Set"===e)return Array.from(t);if("Arguments"===e||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))return y(t,n)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function y(t, n){(null==n||n>t.length)&&(n=t.length);for(var e=0,r=new Array(n); e<n; e++)r[e]=t[e];return r}Number.isInteger||(Number.isInteger=function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}),Number.EPSILON||(Number.EPSILON=2220446049250313e-31);var g=p(Math.pow(10,-6));function p(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:6;if(Number.isInteger(t))return t;var e=Math.pow(10,n);return Math.round((+t+Number.EPSILON)*e)/e}function d(t, n){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:g;return Math.abs(t-n)<e}var m=Math.PI/180;function b(t){return t}function w(t, n, e){var r=1-e;return 3*e*r*(t*r+n*e)+e*e*e}function A(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;return t<0||t>1||e<0||e>1?null:d(t,n)&&d(e,r)?b:function(i){if(i<=0)return t>0?i*n/t:0===n&&e>0?i*r/e:0;if(i>=1)return e<1?1+(i-1)*(r-1)/(e-1):1===e&&t<1?1+(i-1)*(n-1)/(t-1):1;for(var u,o=0,a=1; o<a;){var l=w(t,e,u=(o+a)/2);if(d(i,l))break;l<i?o=u:a=u}return w(n,r,u)}}function _(){return 1}function x(t){return 1===t?1:0}function k(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;if(1===t){if(0===n)return x;if(1===n)return _}var e=1/t;return function(t){return t>=1?1:(t+=n*e)-t%e}}var S=Math.sin,O=Math.cos,j=Math.acos,E=Math.asin,M=Math.tan,P=Math.atan2,I=Math.PI/180,R=180/Math.PI,F=Math.sqrt,N=function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,u=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;r(this,t),this.m=[n,e,i,u,o,a],this.i=null,this.w=null,this.s=null}return u(t,[{key:"determinant",get:function(){var t=this.m;return t[0]*t[3]-t[1]*t[2]}},{key:"isIdentity",get:function(){if(null===this.i){var t=this.m;this.i=1===t[0]&&0===t[1]&&0===t[2]&&1===t[3]&&0===t[4]&&0===t[5]}return this.i}},{key:"point",value:function(t, n){var e=this.m;return{x:e[0]*t+e[2]*n+e[4],y:e[1]*t+e[3]*n+e[5]}}},{key:"translateSelf",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;if(!t&&!n)return this;var e=this.m;return e[4]+=e[0]*t+e[2]*n,e[5]+=e[1]*t+e[3]*n,this.w=this.s=this.i=null,this}},{key:"rotateSelf",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;if(t%=360){var n=S(t*=I),e=O(t),r=this.m,i=r[0],u=r[1];r[0]=i*e+r[2]*n,r[1]=u*e+r[3]*n,r[2]=r[2]*e-i*n,r[3]=r[3]*e-u*n,this.w=this.s=this.i=null}return this}},{key:"scaleSelf",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;if(1!==t||1!==n){var e=this.m;e[0]*=t,e[1]*=t,e[2]*=n,e[3]*=n,this.w=this.s=this.i=null}return this}},{key:"skewSelf",value:function(t, n){if(n%=360,(t%=360)||n){var e=this.m,r=e[0],i=e[1],u=e[2],o=e[3];t&&(t=M(t*I),e[2]+=r*t,e[3]+=i*t),n&&(n=M(n*I),e[0]+=u*n,e[1]+=o*n),this.w=this.s=this.i=null}return this}},{key:"resetSelf",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,u=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,o=this.m;return o[0]=t,o[1]=n,o[2]=e,o[3]=r,o[4]=i,o[5]=u,this.w=this.s=this.i=null,this}},{key:"recomposeSelf",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:null;return this.isIdentity||this.resetSelf(),t&&(t.x||t.y)&&this.translateSelf(t.x,t.y),n&&this.rotateSelf(n),e&&(e.x&&this.skewSelf(e.x,0),e.y&&this.skewSelf(0,e.y)),!r||1===r.x&&1===r.y||this.scaleSelf(r.x,r.y),i&&(i.x||i.y)&&this.translateSelf(i.x,i.y),this}},{key:"decompose",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,e=this.m,r=e[0]*e[0]+e[1]*e[1],i=[[e[0],e[1]],[e[2],e[3]]],u=F(r);if(0===u)return{origin:{x:p(e[4]),y:p(e[5])},translate:{x:p(t),y:p(n)},scale:{x:0,y:0},skew:{x:0,y:0},rotate:0};i[0][0]/=u,i[0][1]/=u;var o=e[0]*e[3]-e[1]*e[2]<0;o&&(u=-u);var a=i[0][0]*i[1][0]+i[0][1]*i[1][1];i[1][0]-=i[0][0]*a,i[1][1]-=i[0][1]*a;var l=F(i[1][0]*i[1][0]+i[1][1]*i[1][1]);if(0===l)return{origin:{x:p(e[4]),y:p(e[5])},translate:{x:p(t),y:p(n)},scale:{x:p(u),y:0},skew:{x:0,y:0},rotate:0};i[1][0]/=l,i[1][1]/=l,a/=l;var s=0;return i[1][1]<0?(s=j(i[1][1])*R,i[0][1]<0&&(s=360-s)):s=E(i[0][1])*R,o&&(s=-s),a=P(a,F(i[0][0]*i[0][0]+i[0][1]*i[0][1]))*R,o&&(a=-a),{origin:{x:p(e[4]),y:p(e[5])},translate:{x:p(t),y:p(n)},scale:{x:p(u),y:p(l)},skew:{x:p(a),y:0},rotate:p(s)}}},{key:"clone",value:function(){var t=this.m;return new this.constructor(t[0],t[1],t[2],t[3],t[4],t[5])}},{key:"toString",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:" ";if(null===this.s){var n=this.m.map((function(t){return p(t)}));1===n[0]&&0===n[1]&&0===n[2]&&1===n[3]?this.s="translate("+n[4]+t+n[5]+")":this.s="matrix("+n.join(t)+")"}return this.s}}],[{key:"create",value:function(t){return t?Array.isArray(t)?f(this,v(t)):t instanceof this?t.clone():(new this).recomposeSelf(t.origin,t.rotate,t.skew,t.scale,t.translate):new this}}]),t}();function T(t, n, e){return t>=.5?e:n}function q(t, n, e){return 0===t||n===e?n:t*(e-n)+n}function B(t, n, e){var r=q(t,n,e);return r<=0?0:r}function D(t, n, e){var r=q(t,n,e);return r<=0?0:r>=1?1:r}function L(t, n, e){return 0===t?n:1===t?e:{x:q(t,n.x,e.x),y:q(t,n.y,e.y)}}function C(t, n, e){var r=function(t, n, e){return Math.round(q(t,n,e))}(t,n,e);return r<=0?0:r>=255?255:r}function V(t, n, e){return 0===t?n:1===t?e:{r:C(t,n.r,e.r),g:C(t,n.g,e.g),b:C(t,n.b,e.b),a:q(t,null==n.a?1:n.a,null==e.a?1:e.a)}}function G(t, n){for(var e=[],r=0; r<t; r++)e.push(n);return e}function z(t, n){if(--n<=0)return t;var e=(t=Object.assign([],t)).length;do{for(var r=0; r<e; r++)t.push(t[r])}while(--n>0);return t}var Y,$=function(){function t(n){r(this,t),this.list=n,this.length=n.length}return u(t,[{key:"setAttribute",value:function(t, n){for(var e=this.list,r=0; r<this.length; r++)e[r].setAttribute(t,n)}},{key:"removeAttribute",value:function(t){for(var n=this.list,e=0; e<this.length; e++)n[e].removeAttribute(t)}},{key:"style",value:function(t, n){for(var e=this.list,r=0; r<this.length; r++)e[r].style[t]=n}}]),t}(),U=/-./g,Q=function(t, n){return n.toUpperCase()};function H(t){return"function"==typeof t?t:T}function J(t){return t?"function"==typeof t?t:Array.isArray(t)?function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:b;if(!Array.isArray(t))return n;switch(t.length){case 1:return k(t[0])||n;case 2:return k(t[0],t[1])||n;case 4:return A(t[0],t[1],t[2],t[3])||n}return n}(t,null):function(t, n){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:b;switch(t){case"linear":return b;case"steps":return k(n.steps||1,n.jump||0)||e;case"bezier":case"cubic-bezier":return A(n.x1||0,n.y1||0,n.x2||0,n.y2||0)||e}return e}(t.type,t.value,null):null}function Z(t, n, e){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=n.length-1;if(t<=n[0].t)return r?[0,0,n[0].v]:n[0].v;if(t>=n[i].t)return r?[i,1,n[i].v]:n[i].v;var u,o=n[0],a=null;for(u=1; u<=i; u++){if(!(t>n[u].t)){a=n[u];break}o=n[u]}return null==a?r?[i,1,n[i].v]:n[i].v:o.t===a.t?r?[u,1,a.v]:a.v:(t=(t-o.t)/(a.t-o.t),o.e&&(t=o.e(t)),r?[u,t,e(t,o.v,a.v)]:e(t,o.v,a.v))}function K(t, n){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;return t&&t.length?"function"!=typeof n?null:("function"!=typeof e&&(e=null),function(r){var i=Z(r,t,n);return null!=i&&e&&(i=e(i)),i}):null}function W(t, n){return t.t-n.t}function X(t, n, r, i, u){var o,a="@"===r[0],l="#"===r[0],s=Y[r],f=T;switch(a?(o=r.substr(1),r=o.replace(U,Q)):l&&(r=r.substr(1)),e(s)){case"function":if(f=s(i,u,Z,J,r,a,n,t),l)return f;break;case"string":f=K(i,H(s));break;case"object":if((f=K(i,H(s.i),s.f))&&"function"==typeof s.u)return s.u(n,f,r,a,t)}return f?function(t, n, e){if(arguments.length>3&&void 0!==arguments[3]&&arguments[3])return t instanceof $?function(r){return t.style(n,e(r))}:function(r){return t.style[n]=e(r)};if(Array.isArray(n)){var r=n.length;return function(i){var u=e(i);if(null==u)for(var o=0; o<r; o++)t[o].removeAttribute(n);else for(var a=0; a<r; a++)t[a].setAttribute(n,u)}}return function(r){var i=e(r);null==i?t.removeAttribute(n):t.setAttribute(n,i)}}(n,r,f,a):null}function tt(t, n, r, i){if(!i||"object"!==e(i))return null;var u=null,o=null;return Array.isArray(i)?o=function(t){if(!t||!t.length)return null;for(var n=0; n<t.length; n++)t[n].e&&(t[n].e=J(t[n].e));return t.sort(W)}(i):(o=i.keys,u=i.data||null),o?X(t,n,r,o,u):null}function nt(t, n, e){if(!e)return null;var r=[];for(var i in e)if(e.hasOwnProperty(i)){var u=tt(t,n,i,e[i]);u&&r.push(u)}return r.length?r:null}function et(t, n){if(!n.settings.duration||n.settings.duration<0)return null;var e,r,i,u,o,a=function(t, n){if(!n)return null;var e=[];if(Array.isArray(n))for(var r=n.length,i=0; i<r; i++){var u=n[i];if(2===u.length){var o=null;if("string"==typeof u[0])o=t.getElementById(u[0]);else if(Array.isArray(u[0])){o=[];for(var a=0; a<u[0].length; a++)if("string"==typeof u[0][a]){var l=t.getElementById(u[0][a]);l&&o.push(l)}o=o.length?1===o.length?o[0]:new $(o):null}if(o){var s=nt(t,o,u[1]);s&&(e=e.concat(s))}}}else for(var f in n)if(n.hasOwnProperty(f)){var c=t.getElementById(f);if(c){var h=nt(t,c,n[f]);h&&(e=e.concat(h))}}return e.length?e:null}(t,n.elements);return a?(e=a,r=n.settings,i=r.duration,u=e.length,o=null,function(t, n){var a=r.iterations||1/0,l=(r.alternate&&a%2==0)^r.direction>0?i:0,s=t%i,f=1+(t-s)/i;n*=r.direction,r.alternate&&f%2==0&&(n=-n);var c=!1;if(f>a)s=l,c=!0,-1===r.fill&&(s=r.direction>0?0:i);else if(n<0&&(s=i-s),s===o)return!1;o=s;for(var h=0; h<u; h++)e[h](s);return c}):null}function rt(t, n){if(Y=n,!t||!t.root||!Array.isArray(t.animations))return null;var e=function(t){for(var n=document.getElementsByTagName("svg"),e=0; e<n.length; e++)if(n[e].id===t.root&&!n[e].svgatorAnimation)return n[e].svgatorAnimation=!0,n[e];return null}(t);if(!e)return null;var r=t.animations.map((function(t){return et(e,t)})).filter((function(t){return!!t}));return r.length?{svg:e,animations:r,animationSettings:t.animationSettings,options:t.options||void 0}:null}function it(t){return+("0x"+(t.replace(/[^0-9a-fA-F]+/g,"")||27))}function ut(t, n, e){return!t||!e||n>t.length?t:t.substring(0,n)+ut(t.substring(n+1),e,e)}function ot(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:27;return!t||t%n?t%n:ot(t/n,n)}function at(t, n, e){if(t&&t.length){var r=it(e),i=it(n),u=ot(r)+5,o=ut(t,ot(r,5),u);return o=o.replace(/\x7c$/g,"==").replace(/\x2f$/g,"="),o=function(t, n, e){var r=+("0x"+t.substring(0,4));t=t.substring(4);for(var i=n%r+e%27,u=[],o=0; o<t.length; o+=2)if("|"!==t[o]){var a=+("0x"+t[o]+t[o+1])-i;u.push(a)}else{var l=+("0x"+t.substring(o+1,o+1+4))-i;o+=3,u.push(l)}return String.fromCharCode.apply(String,u)}(o=(o=atob(o)).replace(/[\x41-\x5A]/g,""),i,r),o=JSON.parse(o)}}var lt=[{key:"alternate",def:!1},{key:"fill",def:1},{key:"iterations",def:0},{key:"direction",def:1},{key:"speed",def:1},{key:"fps",def:100}],st=function(){function t(n, e){var i=this,u=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;r(this,t),this._id=0,this._running=!1,this._rollingBack=!1,this._animations=n,this._settings=e,(!u||u<"2022-05-02")&&delete this._settings.speed,lt.forEach((function(t){i._settings[t.key]=i._settings[t.key]||t.def})),this.duration=e.duration,this.offset=e.offset||0,this.rollbackStartOffset=0}return u(t,[{key:"alternate",get:function(){return this._settings.alternate}},{key:"fill",get:function(){return this._settings.fill}},{key:"iterations",get:function(){return this._settings.iterations}},{key:"direction",get:function(){return this._settings.direction}},{key:"speed",get:function(){return this._settings.speed}},{key:"fps",get:function(){return this._settings.fps}},{key:"maxFiniteDuration",get:function(){return this.iterations>0?this.iterations*this.duration:this.duration}},{key:"_apply",value:function(t){for(var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},e=this._animations,r=e.length,i=0,u=0; u<r; u++)n[u]?i++:(n[u]=e[u](t,1),n[u]&&i++);return i}},{key:"_rollback",value:function(t){var n=this,e=1/0,r=null;this.rollbackStartOffset=t,this._rollingBack=!0,this._running=!0;this._id=window.requestAnimationFrame((function i(u){if(n._rollingBack){null==r&&(r=u);var o=Math.round(t-(u-r)*n.speed);if(o>n.duration&&e!==1/0){var a=!!n.alternate&&o/n.duration%2>1,l=o%n.duration;o=(l+=a?n.duration:0)||n.duration}var s=(n.fps?1e3/n.fps:0)*n.speed,f=Math.max(0,o);f<=e-s&&(n.offset=f,e=f,n._apply(f));var c=n.iterations>0&&-1===n.fill&&o>=n.maxFiniteDuration;(o<=0||n.offset<o||c)&&n.stop(),n._id=window.requestAnimationFrame(i)}}))}},{key:"_start",value:function(){var t=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=-1/0,r=null,i={};this._running=!0;var u=function u(o){null==r&&(r=o);var a=Math.round((o-r)*t.speed+n),l=(t.fps?1e3/t.fps:0)*t.speed;if(a>=e+l&&!t._rollingBack&&(t.offset=a,e=a,t._apply(a,i)===t._animations.length))return void t.pause(!0);t._id=window.requestAnimationFrame(u)};this._id=window.requestAnimationFrame(u)}},{key:"_pause",value:function(){this._id&&window.cancelAnimationFrame(this._id),this._running=!1}},{key:"play",value:function(){if(!this._running)return this._rollingBack?this._rollback(this.offset):this._start(this.offset)}},{key:"stop",value:function(){this._pause(),this.offset=0,this.rollbackStartOffset=0,this._rollingBack=!1,this._apply(0)}},{key:"reachedToEnd",value:function(){return this.iterations>0&&this.offset>=this.iterations*this.duration}},{key:"restart",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.stop(t),this.play(t)}},{key:"pause",value:function(){this._pause()}},{key:"reverse",value:function(){this.direction=-this.direction}}],[{key:"build",value:function(t, n){delete t.animationSettings,t.options=at(t.options,t.root,"5c7f360c"),t.animations.map((function(n){n.settings=at(n.s,t.root,"5c7f360c"),delete n.s,t.animationSettings||(t.animationSettings=n.settings)}));var e=t.version;if(!(t=rt(t,n)))return null;var r=t.options||{},i=new this(t.animations,t.animationSettings,e);return{el:t.svg,options:r,player:i}}},{key:"push",value:function(t){return this.build(t)}},{key:"init",value:function(){var t=this,n=window.__SVGATOR_PLAYER__&&window.__SVGATOR_PLAYER__["5c7f360c"];Array.isArray(n)&&n.splice(0).forEach((function(n){return t.build(n)}))}}]),t}();function ft(t){return p(t)+""}function ct(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:" ";return t&&t.length?t.map(ft).join(n):""}function ht(t){if(!t)return"transparent";if(null==t.a||t.a>=1){var n=function(t){return 1===(t=parseInt(t).toString(16)).length?"0"+t:t},e=function(t){return t.charAt(0)===t.charAt(1)},r=n(t.r),i=n(t.g),u=n(t.b);return e(r)&&e(i)&&e(u)&&(r=r.charAt(0),i=i.charAt(0),u=u.charAt(0)),"#"+r+i+u}return"rgba("+t.r+","+t.g+","+t.b+","+t.a+")"}function vt(t){return t?"url(#"+t+")":"none"}!function(){for(var t=0,n=["ms","moz","webkit","o"],e=0; e<n.length&&!window.requestAnimationFrame; ++e)window.requestAnimationFrame=window[n[e]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[n[e]+"CancelAnimationFrame"]||window[n[e]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(n){var e=Date.now(),r=Math.max(0,16-(e-t)),i=window.setTimeout((function(){n(e+r)}),r);return t=e+r,i},window.cancelAnimationFrame=window.clearTimeout)}();var yt={f:null,i:function(t, n, e){return 0===t?n:1===t?e:{x:B(t,n.x,e.x),y:B(t,n.y,e.y)}},u:function(t, n){return function(e){var r=n(e);t.setAttribute("rx",ft(r.x)),t.setAttribute("ry",ft(r.y))}}},gt={f:null,i:function(t, n, e){return 0===t?n:1===t?e:{width:B(t,n.width,e.width),height:B(t,n.height,e.height)}},u:function(t, n){return function(e){var r=n(e);t.setAttribute("width",ft(r.width)),t.setAttribute("height",ft(r.height))}}};Object.freeze({M:2,L:2,Z:0,H:1,V:1,C:6,Q:4,T:2,S:4,A:7});var pt={},dt=null;function mt(t){var n=function(){if(dt)return dt;if("object"!==("undefined"==typeof document?"undefined":e(document))||!document.createElementNS)return{};var t=document.createElementNS("http://www.w3.org/2000/svg","svg");return t&&t.style?(t.style.position="absolute",t.style.opacity="0.01",t.style.zIndex="-9999",t.style.left="-9999px",t.style.width="1px",t.style.height="1px",dt={svg:t}):{}}().svg;if(!n)return function(t){return null};var r=document.createElementNS(n.namespaceURI,"path");r.setAttributeNS(null,"d",t),r.setAttributeNS(null,"fill","none"),r.setAttributeNS(null,"stroke","none"),n.appendChild(r);var i=r.getTotalLength();return function(t){var n=r.getPointAtLength(i*t);return{x:n.x,y:n.y}}}function bt(t){return pt[t]?pt[t]:pt[t]=mt(t)}function wt(t, n, e, r){if(!t||!r)return!1;var i=["M",t.x,t.y];if(n&&e&&(i.push("C"),i.push(n.x),i.push(n.y),i.push(e.x),i.push(e.y)),n?!e:e){var u=n||e;i.push("Q"),i.push(u.x),i.push(u.y)}return n||e||i.push("L"),i.push(r.x),i.push(r.y),i.join(" ")}function At(t, n, e, r){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1,u=wt(t,n,e,r),o=bt(u);try{return o(i)}catch(t){return null}}function _t(t, n, e){return t+(n-t)*e}function xt(t, n, e){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i={x:_t(t.x,n.x,e),y:_t(t.y,n.y,e)};return r&&(i.a=kt(t,n)),i}function kt(t, n){return Math.atan2(n.y-t.y,n.x-t.x)}function St(t, n, e, r){var i=1-r;return i*i*t+2*i*r*n+r*r*e}function Ot(t, n, e, r){return 2*(1-r)*(n-t)+2*r*(e-n)}function jt(t, n, e, r){var i=arguments.length>4&&void 0!==arguments[4]&&arguments[4],u=At(t,n,null,e,r);return u||(u={x:St(t.x,n.x,e.x,r),y:St(t.y,n.y,e.y,r)}),i&&(u.a=Et(t,n,e,r)),u}function Et(t, n, e, r){return Math.atan2(Ot(t.y,n.y,e.y,r),Ot(t.x,n.x,e.x,r))}function Mt(t, n, e, r, i){var u=i*i;return i*u*(r-t+3*(n-e))+3*u*(t+e-2*n)+3*i*(n-t)+t}function Pt(t, n, e, r, i){var u=1-i;return 3*(u*u*(n-t)+2*u*i*(e-n)+i*i*(r-e))}function It(t, n, e, r, i){var u=arguments.length>5&&void 0!==arguments[5]&&arguments[5],o=At(t,n,e,r,i);return o||(o={x:Mt(t.x,n.x,e.x,r.x,i),y:Mt(t.y,n.y,e.y,r.y,i)}),u&&(o.a=Rt(t,n,e,r,i)),o}function Rt(t, n, e, r, i){return Math.atan2(Pt(t.y,n.y,e.y,r.y,i),Pt(t.x,n.x,e.x,r.x,i))}function Ft(t, n, e){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(Tt(n)){if(qt(e))return jt(n,e.start,e,t,r)}else if(Tt(e)){if(Bt(n))return jt(n,n.end,e,t,r)}else{if(Bt(n))return qt(e)?It(n,n.end,e.start,e,t,r):jt(n,n.end,e,t,r);if(qt(e))return jt(n,e.start,e,t,r)}return xt(n,e,t,r)}function Nt(t, n, e){var r=Ft(t,n,e,!0);return r.a=function(t){return arguments.length>1&&void 0!==arguments[1]&&arguments[1]?t+Math.PI:t}(r.a)/m,r}function Tt(t){return!t.type||"corner"===t.type}function qt(t){return null!=t.start&&!Tt(t)}function Bt(t){return null!=t.end&&!Tt(t)}var Dt=new N;var Lt={f:ft,i:q},Ct={f:ft,i:D};function Vt(t, n, e){return t.map((function(t){return function(t, n, e){var r=t.v;if(!r||"g"!==r.t||r.s||!r.v||!r.r)return t;var i=e.getElementById(r.r),u=i&&i.querySelectorAll("stop")||[];return r.s=r.v.map((function(t, n){var e=u[n]&&u[n].getAttribute("offset");return{c:t,o:e=p(parseInt(e)/100)}})),delete r.v,t}(t,0,e)}))}var Gt={gt:"gradientTransform",c:{x:"cx",y:"cy"},rd:"r",f:{x:"x1",y:"y1"},to:{x:"x2",y:"y2"}};function zt(t, n, r, i, u, o, a, l){return Vt(t,0,l),n=function(t, n, e){for(var r,i,u,o=t.length-1,a={},l=0; l<=o; l++)(r=t[l]).e&&(r.e=n(r.e)),r.v&&"g"===(i=r.v).t&&i.r&&(u=e.getElementById(i.r))&&(a[i.r]={e:u,s:u.querySelectorAll("stop")});return a}(t,i,l),function(i){var u=r(i,t,Yt);if(!u)return"none";if("c"===u.t)return ht(u.v);if("g"===u.t){if(!n[u.r])return vt(u.r);var o=n[u.r];return function(t, n){for(var e=t.s,r=e.length; r<n.length; r++){var i=e[e.length-1].cloneNode();i.id=Qt(i.id),t.e.appendChild(i),e=t.s=t.e.querySelectorAll("stop")}for(var u=0,o=e.length,a=n.length-1; u<o; u++)e[u].setAttribute("stop-color",ht(n[Math.min(u,a)].c)),e[u].setAttribute("offset",n[Math.min(u,a)].o)}(o,u.s),Object.keys(Gt).forEach((function(t){if(void 0!==u[t])if("object"!==e(Gt[t])){var n,r="gt"===t?(n=u[t],Array.isArray(n)?"matrix("+n.join(" ")+")":""):u[t],i=Gt[t];o.e.setAttribute(i,r)}else Object.keys(Gt[t]).forEach((function(n){if(void 0!==u[t][n]){var e=u[t][n],r=Gt[t][n];o.e.setAttribute(r,e)}}))})),vt(u.r)}return"none"}}function Yt(t, e, r){if(0===t)return e;if(1===t)return r;if(e&&r){var i=e.t;if(i===r.t)switch(e.t){case"c":return{t:i,v:V(t,e.v,r.v)};case"g":if(e.r===r.r){var u={t:i,s:$t(t,e.s,r.s),r:e.r};return e.gt&&r.gt&&(u.gt=function(t, n, e){var r=n.length;if(r!==e.length)return T(t,n,e);for(var i=new Array(r),u=0; u<r; u++)i[u]=q(t,n[u],e[u]);return i}(t,e.gt,r.gt)),e.c?(u.c=L(t,e.c,r.c),u.rd=B(t,e.rd,r.rd)):e.f&&(u.f=L(t,e.f,r.f),u.to=L(t,e.to,r.to)),u}}if("c"===e.t&&"g"===r.t||"c"===r.t&&"g"===e.t){var o="c"===e.t?e:r,a="g"===e.t?n({},e):n({},r),l=a.s.map((function(t){return{c:o.v,o:t.o}}));return a.s="c"===e.t?$t(t,l,a.s):$t(t,a.s,l),a}}return T(t,e,r)}function $t(t, n, e){if(n.length===e.length)return n.map((function(n, r){return Ut(t,n,e[r])}));for(var r=Math.max(n.length,e.length),i=[],u=0; u<r; u++){var o=Ut(t,n[Math.min(u,n.length-1)],e[Math.min(u,e.length-1)]);i.push(o)}return i}function Ut(t, n, e){return{o:D(t,n.o,e.o||0),c:V(t,n.c,e.c||{})}}function Qt(t){return t.replace(/-fill-([0-9]+)$/,(function(t, n){return"-fill-"+(+n+1)}))}var Ht={fill:zt,"fill-opacity":Ct,stroke:zt,"stroke-opacity":Ct,"stroke-width":Lt,"stroke-dashoffset":{f:ft,i:q},"stroke-dasharray":{f:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:" ";return t&&t.length>0&&(t=t.map((function(t){return p(t,4)}))),ct(t,n)},i:function(t, n, e){var r,i,u,o=n.length,a=e.length;if(o!==a)if(0===o)n=G(o=a,0);else if(0===a)a=o,e=G(o,0);else{var l=(u=(r=o)*(i=a)/function(t, n){for(var e; n;)e=n,n=t%n,t=e;return t||1}(r,i))<0?-u:u;n=z(n,Math.floor(l/o)),e=z(e,Math.floor(l/a)),o=a=l}for(var s=[],f=0; f<o; f++)s.push(p(B(t,n[f],e[f])));return s}},opacity:Ct,transform:function(t, n, r, i){if(!(t=function(t, n){if(!t||"object"!==e(t))return null;var r=!1;for(var i in t)t.hasOwnProperty(i)&&(t[i]&&t[i].length?(t[i].forEach((function(t){t.e&&(t.e=n(t.e))})),r=!0):delete t[i]);return r?t:null}(t,i)))return null;var u=function(e, i, u){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;return t[e]?r(i,t[e],u):n&&n[e]?n[e]:o};return n&&n.a&&t.o?function(n){var e=r(n,t.o,Nt);return Dt.recomposeSelf(e,u("r",n,q,0)+e.a,u("k",n,L),u("s",n,L),u("t",n,L)).toString()}:function(t){return Dt.recomposeSelf(u("o",t,Ft,null),u("r",t,q,0),u("k",t,L),u("s",t,L),u("t",t,L)).toString()}},r:Lt,"#size":gt,"#radius":yt,_:function(t, n){if(Array.isArray(t))for(var e=0; e<t.length; e++)this[t[e]]=n;else this[t]=n}},Jt=function(t){!function(t, n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&l(t,n)}(o,t);var n,e,i=(n=o,e=s(),function(){var t,r=a(n);if(e){var i=a(this).constructor;t=Reflect.construct(r,arguments,i)}else t=r.apply(this,arguments);return c(this,t)});function o(){return r(this,o),i.apply(this,arguments)}return u(o,null,[{key:"build",value:function(t){var n=h(a(o),"build",this).call(this,t,Ht);if(!n)return null;n.el,n.options,function(t, n, e){t.play()}(n.player)}}]),o}(st);return Jt.init(),Jt}));(function(s, i, o, w, d, a, b){w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);})('5c7f360c',{"root":"exP19HkYJ3c1","version":"2022-05-04","animations":[{"elements":{"exP19HkYJ3c4":{"transform":{"keys":{"o":[{"t":0,"v":{"x":90,"y":28,"type":"cusp","end":{"x":90.171668,"y":34.808033}}},{"t":1000,"v":{"x":101.764216,"y":39.000001,"type":"cusp","start":{"x":96.685379,"y":39.171147}}},{"t":2000,"v":{"x":115.5,"y":33.706879,"type":"cusp","start":{"x":111.276033,"y":38.090084},"end":{"x":122.228999,"y":27.644256}}},{"t":3000,"v":{"x":107.5,"y":22.423105,"type":"cusp","start":{"x":116.77947,"y":20.762382}}},{"t":4000,"v":{"x":94.5,"y":25.71474,"type":"cusp","start":{"x":102.429713,"y":23.437537}}},{"t":5000,"v":{"x":78.382565,"y":28.098976,"type":"cusp","start":{"x":87.338851,"y":28.098976}}},{"t":6000,"v":{"x":75.426113,"y":14.556515,"type":"cusp","start":{"x":68.932549,"y":25.107498}}},{"t":7000,"v":{"x":86.718972,"y":10.646367,"type":"cusp","start":{"x":78.94634,"y":10.229866}}},{"t":8000,"v":{"x":96.542024,"y":18,"type":"cusp","start":{"x":95.922101,"y":11.374299}}},{"t":9000,"v":{"x":90,"y":28,"type":"cusp","start":{"x":97.257273,"y":23.963065}}}]}}},"exP19HkYJ3c5":{"transform":{"keys":{"o":[{"t":0,"v":{"x":74.5,"y":100.5,"type":"cusp","end":{"x":75.924749,"y":105.977709}}},{"t":1000,"v":{"x":67.264216,"y":116.500001,"type":"cusp","start":{"x":76.405343,"y":116.500003}}},{"t":2000,"v":{"x":52.887519,"y":111.206879,"type":"cusp","start":{"x":57.94831,"y":116.072508}}},{"t":3000,"v":{"x":56.391839,"y":99.5,"type":"cusp","start":{"x":49.185422,"y":105.150995}}},{"t":4000,"v":{"x":67.5,"y":101.5,"type":"cusp","start":{"x":61.5,"y":96.299968}}},{"t":5000,"v":{"x":80.267791,"y":106.5,"type":"cusp","start":{"x":72.815448,"y":105.537865}}},{"t":6000,"v":{"x":90,"y":99.5,"type":"cusp","start":{"x":87.764306,"y":106.812569}}},{"t":7000,"v":{"x":86.718972,"y":89.949866,"type":"cusp","start":{"x":91.455462,"y":92.926791}}},{"t":8000,"v":{"x":75.645504,"y":88.5,"type":"cusp","start":{"x":81.729559,"y":87.94666}}},{"t":9000,"v":{"x":74.532298,"y":100.5,"type":"cusp","start":{"x":70.013459,"y":89.880123}}}]}}},"exP19HkYJ3c6":{"transform":{"keys":{"o":[{"t":0,"v":{"x":42.5,"y":78.5,"type":"cusp","end":{"x":48.106031,"y":80.696487}}},{"t":1000,"v":{"x":60.264216,"y":73,"type":"cusp","start":{"x":57.116095,"y":78.436982}}},{"t":2000,"v":{"x":62.5,"y":61,"type":"cusp","start":{"x":63.813934,"y":66.70874}}},{"t":3000,"v":{"x":47,"y":55.5,"type":"cusp","start":{"x":59,"y":51}}},{"t":4000,"v":{"x":40,"y":67,"type":"cusp","start":{"x":40,"y":59}}},{"t":5000,"v":{"x":47,"y":76.5,"type":"cusp","start":{"x":40,"y":72}}},{"t":6000,"v":{"x":55.5,"y":84.385836,"type":"cusp","start":{"x":55.5,"y":80.186403}}},{"t":7000,"v":{"x":47,"y":93.479505,"type":"cusp","start":{"x":54.47595,"y":92.479505}}},{"t":8000,"v":{"x":31.107034,"y":88.5,"type":"cusp","start":{"x":36.647105,"y":93.786612},"end":{"x":27.5,"y":83.319728}}},{"t":9000,"v":{"x":42.513459,"y":78.497308,"type":"cusp","start":{"x":33.244283,"y":75.65368}}}]}}},"exP19HkYJ3c7":{"transform":{"keys":{"o":[{"t":0,"v":{"x":139.645681,"y":66,"type":"cusp","end":{"x":134.471621,"y":72.470092}}},{"t":1000,"v":{"x":115.5,"y":71,"type":"cusp","start":{"x":122.375469,"y":74.816232},"end":{"x":109.490493,"y":64.705816}}},{"t":2000,"v":{"x":115.5,"y":53.5,"type":"cusp","start":{"x":110.1712,"y":58.721215}}},{"t":3000,"v":{"x":133,"y":51,"type":"cusp","start":{"x":125.303534,"y":46.346089}}},{"t":4000,"v":{"x":137.5,"y":65,"type":"cusp","start":{"x":139.657632,"y":57.0002}}},{"t":5000,"v":{"x":140.267791,"y":78.5,"type":"cusp","start":{"x":134.844851,"y":72}}},{"t":6000,"v":{"x":153.096311,"y":75,"type":"cusp","start":{"x":148.563471,"y":83.654337}}},{"t":7000,"v":{"x":153.986986,"y":65,"type":"cusp","start":{"x":155.761633,"y":69.964485}}},{"t":8000,"v":{"x":148.016891,"y":57.521595,"type":"cusp","start":{"x":152.261635,"y":59.464492},"end":{"x":143.213068,"y":56.588813}}},{"t":9000,"v":{"x":139.615113,"y":66,"type":"cusp","start":{"x":141.360189,"y":63.446644}}}]}}},"exP19HkYJ3c8":{"transform":{"keys":{"o":[{"t":0,"v":{"x":118.5,"y":106.5,"type":"cusp","end":{"x":125.496315,"y":111.133158}}},{"t":1000,"v":{"x":137.5,"y":100.5,"type":"cusp","start":{"x":134.981671,"y":108.093409}}},{"t":2000,"v":{"x":133,"y":88.022292,"type":"cusp","start":{"x":141.687324,"y":88.022292}}},{"t":3000,"v":{"x":118.5,"y":94.5,"type":"cusp","start":{"x":122.777976,"y":87.734047}}},{"t":4000,"v":{"x":109,"y":106,"type":"cusp","start":{"x":112.511621,"y":102.391858},"end":{"x":104.30393,"y":110.047958}}},{"t":5000,"v":{"x":99.5,"y":100.5,"type":"cusp","start":{"x":99.544406,"y":107.219368}}},{"t":6000,"v":{"x":103.05859,"y":91.753672,"type":"cusp","start":{"x":99.776157,"y":95.105832}}},{"t":7000,"v":{"x":113.465768,"y":92.479505,"type":"cusp","start":{"x":109.205226,"y":87.811171}}},{"t":8000,"v":{"x":112.630042,"y":99.705969,"type":"cusp","start":{"x":116.095166,"y":95.6245},"end":{"x":107.36762,"y":105.3582}}},{"t":9000,"v":{"x":118.5,"y":106.499992,"type":"cusp","start":{"x":115.033865,"y":103.149274}}}]}}},"exP19HkYJ3c9":{"transform":{"keys":{"o":[{"t":0,"v":{"x":55,"y":47,"type":"cusp","end":{"x":47,"y":42}}},{"t":1000,"v":{"x":42.5,"y":28,"type":"cusp","start":{"x":54.002187,"y":28}}},{"t":2000,"v":{"x":32.149466,"y":42,"type":"cusp","start":{"x":32.149466,"y":27.590084}}},{"t":3000,"v":{"x":40,"y":59,"type":"cusp","start":{"x":31.618285,"y":51}}},{"t":4000,"v":{"x":61.5,"y":59,"type":"cusp","start":{"x":54.205677,"y":66}}},{"t":5000,"v":{"x":71,"y":41.703348,"type":"cusp","start":{"x":71,"y":51}}},{"t":6000,"v":{"x":55.5,"y":32,"type":"cusp","start":{"x":70,"y":32}}},{"t":7000,"v":{"x":42.5,"y":46,"type":"cusp","start":{"x":47,"y":31.5}}},{"t":8000,"v":{"x":51,"y":61,"type":"cusp","start":{"x":42.5,"y":55.743738},"end":{"x":58.757985,"y":64.206887}}},{"t":9000,"v":{"x":55.5,"y":47,"type":"cusp","start":{"x":64.982812,"y":52.946245}}}]}}},"exP19HkYJ3c12":{"transform":{"data":{"s":{"x":-1,"y":1.002123}},"keys":{"o":[{"t":0,"v":{"x":45.5,"y":165.255368,"type":"cusp","end":{"x":56.828095,"y":167.299564}}},{"t":1000,"v":{"x":57.264216,"y":151.5,"type":"cusp","start":{"x":58.436259,"y":161.555725}}},{"t":2000,"v":{"x":37.649466,"y":151.522291,"type":"cusp","start":{"x":50,"y":141.000001}}},{"t":3000,"v":{"x":29.243144,"y":170,"type":"cusp","start":{"x":29.243144,"y":159.477709},"end":{"x":29.243144,"y":180.372963}}},{"t":4000,"v":{"x":18.454162,"y":164.783664,"type":"cusp","start":{"x":7.954162,"y":175.305956},"end":{"x":24.047643,"y":159.207443}}},{"t":5000,"v":{"x":38.546451,"y":159.477708,"type":"cusp","start":{"x":29.243144,"y":151.522291}}},{"t":6000,"v":{"x":55.337349,"y":168.058651,"type":"cusp","start":{"x":44.837349,"y":162.842315},"end":{"x":61.818355,"y":175.588055}}},{"t":7000,"v":{"x":52.096846,"y":181.973752,"type":"cusp","start":{"x":54.479569,"y":173.110023}}},{"t":8000,"v":{"x":38.607034,"y":182.204283,"type":"cusp","start":{"x":47.045473,"y":187.501669},"end":{"x":33.416299,"y":177.970778}}},{"t":9000,"v":{"x":45.388769,"y":165.309579,"type":"cusp","start":{"x":36.472216,"y":163.862633}}}]}}},"exP19HkYJ3c13":{"transform":{"data":{"s":{"x":-1,"y":1}},"keys":{"o":[{"t":0,"v":{"x":204.5,"y":41.255368,"type":"cusp","end":{"x":215.53473,"y":44.528236}}},{"t":1000,"v":{"x":208.5,"y":66.5,"type":"cusp","start":{"x":208.5,"y":56}}},{"t":2000,"v":{"x":227.201955,"y":73.090084,"type":"cusp","start":{"x":217.762816,"y":78.923602}}},{"t":3000,"v":{"x":216.701955,"y":57.423105,"type":"cusp","start":{"x":238.547117,"y":63}}},{"t":4000,"v":{"x":192.5,"y":44.388328,"type":"cusp","start":{"x":193.415491,"y":52.5}}},{"t":5000,"v":{"x":215.53473,"y":37.226956,"type":"cusp","start":{"x":192.5,"y":26.726956}}},{"t":6000,"v":{"x":224.096311,"y":52.5,"type":"cusp","start":{"x":228.477021,"y":42}}},{"t":7000,"v":{"x":208.5,"y":66.5,"type":"cusp","start":{"x":219,"y":63}}},{"t":8000,"v":{"x":187.5,"y":57.734572,"type":"cusp","start":{"x":192.5,"y":66.5}}},{"t":9000,"v":{"x":204.5,"y":41.164143,"type":"cusp","start":{"x":182,"y":38.197614}}}]}}}},"s":"MLDA1ZGJiNjJhNGI1YjGJhMWI0YTlhZmFlNjID3YTc5NzA3MDcwNmM2CMmE0YTliMmE1YTNiNHGE5RWFmYWU2MjdhNzHE2Y0Q2MmE5YjRhNWIAyYTFiNGE5YWZhZWIzENjI3YTcwNmM2Mk5hNVmE5SGFjYWM2MjdhNzDE2YzYyYTFhY2I0YTVFiMmFlYTFiNGE1NjI3DYWE2YTFhY2IzQ2E1NImM2MmIzYjBhNVFhNWBE0STYyN2E3MUc2YzYNyYTZiMGIzNjI3YTcxHNzA3MGJk"}],"options":"MADAxMDg4MmY4MDgxTDKZlN2Y4MTJmTzQ3MmYD3OTdjVDZlNzEyZjhhH"},'__SVGATOR_PLAYER__',window,document)

// DOCUMENT READY

$(document).ready(function() {

    // MENU

    $(document).on('click', '.js-menu-toggle', function (e) {
        e.preventDefault();
        $(this).toggleClass('c-header__hamburger--active');
        $('.js-main-menu').toggleClass('c-header__main-menu-container--active');

        if ($(this).hasClass('c-header__hamburger--active')) {
            $('body').addClass('u-no-scroll');
        } else {
            $('body').removeClass('u-no-scroll');
        }
    });

    // SCROLL LINK BEHAVIOUR

    $(document).on('click', '.js-scroll-link', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(target).offset().top - 50
        }, 500);
    });

    // PAGINATION BLOG HACK

    if ($('.c-blog').length && $('.o-breadcrumbs__separator').length >= 2) {
        $('.breadcrumb_last').hide().prev().hide();
    }

    // SUBNAV

    $('.js-main-menu .sub-menu').each(function () {
        $('<div class="c-header__main-menu-toggle-sub js-toggle-sub"></div>').insertBefore($(this));
    });

    $(document).on('click', '.js-toggle-sub', function () {
        $(this).toggleClass('c-header__main-menu-toggle-sub--active');
        $(this).next('.sub-menu').toggleClass('sub-menu--active');
    });

    // SHOW MORE

    $(document).on('click', '.js-show-more', function (e) {
        e.preventDefault();
        $(this).siblings('.js-show-more-target').toggleClass('c-history__item-text--visible');
        if ($(this).hasClass('c-history__item-link--active')) {
            $(this).text('zobrazit více');
        } else {
            $(this).text('zobrazit méně');
        }
        $(this).toggleClass('c-history__item-link--active');
    });

    // SLICK

    var slider = $('.js-slider');

    slider.slick({
        centerMode: false,
        slidesToShow: 3,
        dots: true,
        arrows: false,
        infinite: false,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    var blogSlider = $('.js-blog-slider');

    blogSlider.slick({
        centerMode: false,
        slidesToShow: 4,
        dots: true,
        arrows: false,
        infinite: false,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // TIPS

    function sliderInit() {
        var $slider = $('.js-tips-slider');
        $slider.each(function () {
            var $sliderParent = $(this).parent();
            $(this).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                dots: false,
                arrows: true,
                infinite: true,
                centerPadding: '60px',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '0px',
                        }
                    }
                ]
            });

            if ($(this).find('.item').length > 1) {
                $(this).siblings('.slides-numbers').show();
            }

            $(this).on('afterChange', function (event, slick, currentSlide) {
                $sliderParent.find('.js-slides-numbers .active').html(currentSlide + 1);
            });

            var sliderItemsNum = $(this).find('.slick-slide').not('.slick-cloned').length;
            $sliderParent.find('.js-slides-numbers .total').html(sliderItemsNum);

        });
    }

    sliderInit();

    if ($('.c-blog__menu').length) {
        if ($('.c-blog__menu-item--active').length == 0) {
            $('#category-all').addClass('c-blog__menu-item--active');
        }
    }

    $(document).on('click', '.js-job-item', function () {
        $(this).find('.js-job-text').toggleClass('c-jobs__item-text--active');
    });

    if ($('.c-blog__detail').length) {

        var blogLink = '<span><a href="/blog">Blog</a></span><span class="o-breadcrumbs__separator"></span>';
        $(blogLink).insertBefore('.breadcrumb_last');
    }

    // NUMBER INPUTS

    $('<div class="o-number__button o-number__button--up">+</div>').insertAfter('.o-number__inner');
    $('<div class="o-number__button o-number__button--down">-</div>').insertBefore('.o-number__inner');
    $('.o-number').each(function () {
        var thisInput = $(this);
        var spinner = jQuery(this),
            input = spinner.find('input[type="text"]'),
            btnUp = spinner.find('.o-number__button--up'),
            btnDown = spinner.find('.o-number__button--down'),
            step = parseFloat(spinner.find('input[type="text"]').attr('step')),
            min = input.attr('min'),
            max = input.attr('max');

        var toolTipClosed = false;

        thisInput.find('.js-number-tooltip').find('.js-number-tooltip-close').click(function(){
            $(this).parent().hide();
            toolTipClosed = true;
        });

        function checkTooltip() {
            if(parseInt(input.val().replace(/\s/g, '')) >= parseInt(thisInput.data('tooltip-threshold')) || toolTipClosed == true) {
                thisInput.find('.js-number-tooltip').hide();
            }
            else {
                thisInput.find('.js-number-tooltip').show();
            }
        }

        checkTooltip();

        $(this).on('change', function(){
            checkTooltip();
        });

        btnUp.click(function () {
            var oldValue = input.val();
            oldValue = oldValue.replaceAll(' ', '');
            oldValue = parseFloat(oldValue);

            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + step;
            }

            if (thisInput.hasClass('o-number--floatNumber')) {
                spinner.find("input").val(newVal.toFixed(2));
            } else if (spinner.find('input').hasClass('js-spaced-number')) {
                spinner.find("input").val(spacedNumber(newVal));
            } else {
                spinner.find("input").val(newVal);
            }

            spinner.find("input").trigger("change");
            checkTooltip();
        });

        btnDown.click(function () {
            var oldValue = input.val();
            oldValue = oldValue.replaceAll(' ', '');
            oldValue = parseFloat(oldValue);

            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - step;
            }

            if (thisInput.hasClass('o-number--floatNumber')) {
                spinner.find("input").val(newVal.toFixed(2));
            } else if (spinner.find('input').hasClass('js-spaced-number')) {
                spinner.find("input").val(spacedNumber(newVal));
            } else {
                spinner.find("input").val(newVal);
            }

            spinner.find("input").trigger("change");
            checkTooltip();
        });
    });

    $(document).on('change keyup', '.o-number input.js-spaced-number', function () {
        this.value = this.value.replace(/ /g, '');
        var number = this.value;
        this.value = number.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    });

    function spacedNumber(inputNumber) {
        var inputNumber = inputNumber.toString();
        return inputNumber.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    function validateEmail($email) {
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        return emailReg.test( $email );
    }

    // Form checkbox text

    if ($('.js-acceptance-checkbox').length) {
        const input = document.getElementById('acceptance');
        const validityState = input.validity;

        if (validityState.valueMissing) {
            input.setCustomValidity('Potvrďte, prosím, váš souhlas s podmínkami.');
        } else {
            input.setCustomValidity('');
        }
    }

    // Form phone input

    $(document).on('submit', '.js-form', function (e) {
        var phoneNumber = $('.js-form-phone-input').val();
        var phoneCode = $('.js-form-phone-code').val();

        var inputOne = $('#input_1').val().replace(/\s+/g, '');
        var inputTwo = $('#input_2').val().replace(/\s+/g, '');

        var inputIncome = $("[name='income']").val();

        var newPhoneNumber = phoneCode + phoneNumber;
        $('.js-form-phone-input').val(newPhoneNumber);

        $('#input_1').val(inputOne);
        $('#input_2').val(inputTwo);

        if (inputIncome) {
            inputIncome = inputIncome.replace(/\s+/g, '');
            $("[name='income']").val(inputIncome)
        }
    });

    $(document).on('keyup', '.js-form-phone-input', function () {
        var val = $(this).val();
        var outputVal = val.replace(/^\s*([0-9]{3})\s*\-?([0-9]{3})\s*\-?([0-9]{3})$/, '$1 $2 $3');
        $(this).val(outputVal);
    });

    $(document).on('keyup', '.js-form-phone-input', function (e) {
        var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,3})/);
        e.target.value = !x[2] ? x[1] : '' + x[1] + ' ' + x[2] + (x[3] ? ' ' + x[3] : '');
    });

    // Blog image

    $('.js-blog-item-image img').each(function () {
        if (parseInt($(this).attr('height')) > parseInt($(this).attr('width'))) {
            $(this).addClass('repositioned');
        }
    });

    // Open cookie bar

    $(document).on('click', '.js-open-cookie-bar', function (e) {
        e.preventDefault();
        _dcb.open_config();
    });

    // Handle Iframe parameters

    (function () {

        var url_string = location.href;
        var url = new URL(url_string);
        var aff_sub_id = url.searchParams.get("aff_sub");

        if (aff_sub_id !== null) {
            $.cookie('aff_sub', aff_sub_id, {expires: 2, path: '/'});
        }

        if ($('.js-iframe').length) {
            var iframeSrc = $('.js-iframe').attr('src');
            if (aff_sub_id !== null) {
                $.cookie('aff_sub', aff_sub_id, {expires: 2, path: '/'});
                $('.js-iframe').attr('src', iframeSrc + '&aff_sub=' + aff_sub_id);
            } else if ($.cookie('aff_sub') !== null) {
                $('.js-iframe').attr('src', iframeSrc + '&aff_sub=' + $.cookie('aff_sub'));
            }
            setTimeout(function () {
                $(window).scrollTop(0);
            }, 1000);
        }



        if ($('.js-form-aff-id').length) {
            if (aff_sub_id !== null) {
                $.cookie('aff_sub', aff_sub_id, {expires: 2, path: '/'});
                $('.js-id-lts').each(function(){
                    if($(this).attr('data-id') == aff_sub_id) {
                        $('.js-form-aff-id').val($(this).text());
                    }
                });
            } else if ($.cookie('aff_sub') !== null) {
                $('.js-id-lts').each(function(){
                    if($(this).attr('data-id') == $.cookie('aff_sub')) {
                        $('.js-form-aff-id').val($(this).text());
                    }
                });
            }
        }
    })();

    // form info messages missing inputs

    const nameInputs = document.getElementsByName('_name');
    const surnameInputs = document.getElementsByName('surname');
    const emailInputs = document.getElementsByName('mail');
    const phoneInputs = document.getElementsByName('phone');
    const occupationInputs = document.getElementsByName('occupation');

    const missingInputMessageSet = (inputs, message) => {
        inputs.forEach(input => {
            input.addEventListener("input", function (e) {
                input.setCustomValidity('');
            });
            input.addEventListener("invalid", function (e) {
                input.setCustomValidity(message);
            });
        })
    }

    missingInputMessageSet(nameInputs, 'Vyplňte své jméno');
    missingInputMessageSet(surnameInputs, 'Vyplňte své příjmení');
    missingInputMessageSet(phoneInputs, 'Vyplňte tel. číslo ve formátu 123 456 789');
    missingInputMessageSet(emailInputs, 'Vyplňte e-mail ve formátu jmeno@email.cz');
    missingInputMessageSet(occupationInputs, 'Vyplňte druh svého povolání (např.: manuální práce)');

    $('.js-valorization-select option').each(function(){
        $(this).val($(this).val() / 100);
    });

    // Calculator Savings

    (function () {
        var ctx_new = '';
        var ctx_old = '';
        var leadSent = false;

        function calculateSavings(update) {
            var finalCalculation = 0;
            var ZH = $('#input_2').val();
            var MP = $('#input_3').val();
            var MPZ = $('#input_4').val() * 12 * 10;

            if(update == true) {
                ZH = $('#input_10').val();
                MP = $('#input_11').val();
                MPZ = $('#input_12').val() * 12 * 10;
                $('#input_2').val($('#input_10').val());
                $('#input_3').val($('#input_11').val());
                $('#input_4').val($('#input_12').val());
            }

            else {
                $('#input_10').val($('#input_2').val());
                $('#input_11').val($('#input_3').val());
                $('#input_12').val($('#input_4').val());
            }

            if (MP >= 0 && MP <= 299) {
                var VSP_old = 0;
                var VSP_new = 0;
            } else if (MP >= 300 && MP <= 399) {
                var VSP_old = 90;
                var VSP_new = 0;
            } else if (MP >= 400 && MP <= 499) {
                var VSP_old = 110;
                var VSP_new = 0;
            } else if (MP >= 500 && MP <= 599) {
                var VSP_old = 130;
                var VSP_new = 100;
            } else if (MP >= 600 && MP <= 699) {
                var VSP_old = 150;
                var VSP_new = 120;
            } else if (MP >= 700 && MP <= 799) {
                var VSP_old = 170;
                var VSP_new = 140;
            } else if (MP >= 800 && MP <= 899) {
                var VSP_old = 190;
                var VSP_new = 160;
            } else if (MP >= 900 && MP <= 999) {
                var VSP_old = 210;
                var VSP_new = 180;
            } else if (MP >= 1000 && MP <= 1099) {
                var VSP_old = 230;
                var VSP_new = 200;
            } else if (MP >= 1100 && MP <= 1199) {
                var VSP_old = 230;
                var VSP_new = 220;
            } else if (MP >= 1200 && MP <= 1299) {
                var VSP_old = 230;
                var VSP_new = 240;
            } else if (MP >= 1300 && MP <= 1399) {
                var VSP_old = 230;
                var VSP_new = 260;
            } else if (MP >= 1400 && MP <= 1499) {
                var VSP_old = 230;
                var VSP_new = 280;
            } else if (MP >= 1500 && MP <= 1599) {
                var VSP_old = 230;
                var VSP_new = 300;
            } else if (MP >= 1600 && MP <= 1699) {
                var VSP_old = 230;
                var VSP_new = 320;
            } else if (MP >= 1700) {
                var VSP_old = 230;
                var VSP_new = 340;
            }

            var SP_new = VSP_new * 12 * 10;
            var SP_old = VSP_old * 12 * 10;

            finalCalculation = parseInt(MP * (((Math.pow((1 + (ZH / 12)), 120)) - 1) / (ZH / 12)));
            if (update == false) {
                ctx_new = new Chart(document.getElementById('chart_new'), {
                    type: 'doughnut',
                    options: {
                        animation: true,
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        }
                    },
                    data: {
                        labels: ['Naspořeno a zhodnoceno', 'Příspěvek zaměstnavatele', 'Státní příspěvěk'],
                        datasets: [{
                            data: [finalCalculation, MPZ, SP_new],
                            backgroundColor: ['#05AD71', '#5DB6E2', '#FF9F40'],
                            borderWidth: 0
                        }]
                    }
                });

                setTimeout(function(){
                    $('.js-graph-center').addClass('c-calculator__graph-center-container--visible');
                    $('html, body').animate({
                        scrollTop: $('#calculator').offset().top - 105
                    }, 500);
                }, 500);
            }

            else {
                ctx_new.options = {
                    type: 'doughnut',
                    animation: true,
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            enabled: false
                        }
                    }
                }
                ctx_new.data = {
                    labels: ['Naspořeno a zhodnoceno', 'Příspěvek zaměstnavatele', 'Státní příspěvěk'],
                    datasets: [{
                        data: [finalCalculation, MPZ, SP_new],
                        backgroundColor: ['#05AD71', '#5DB6E2', '#FF9F40'],
                        borderWidth: 0
                    }]
                }
                ctx_new.update();
            }

            $('.js-legend-SP-new').text(spacedNumber(SP_new) + ' Kč');
            $('.js-legend-SP-old').text(spacedNumber(SP_old) + ' Kč');
            $('.js-legend-SPZ-new, .js-legend-SPZ-old').text(spacedNumber(MPZ) + ' Kč');
            $('.js-legend-saved-new, .js-legend-saved-old').text(spacedNumber(parseInt(finalCalculation)) + ' Kč');
            $('.js-legend-total-new').text(spacedNumber(parseInt(SP_new + MPZ + finalCalculation)) + ' Kč');
            $('.js-legend-total-old').text(spacedNumber(parseInt(SP_old + MPZ + finalCalculation)) + ' Kč');
        }

        function hideForm() {
            $('.js-first-form').hide();
            $('.js-second-form, .js-calculator').show();
        }

        $(document).on('click', '.js-reset-form', function (e) {
            e.preventDefault();
            $('.js-first-form').show();
            $('.js-second-form, .js-calculator').hide();
            ctx_new.destroy();
            ctx_old.destroy();

            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $('#form').offset().top - 50
                }, 500);
            }, 100);

            $('.js-graph-center').removeClass('c-calculator__graph-center-container--visible');
        });

        $(document).on('change', '.js-calculator-update', function(){
            calculateSavings(true);
        });

        $(document).on('click', '.js-calculator .o-number__button--up, .js-calculator .o-number__button--down', function(){
            calculateSavings(true);
        });

        $(document).on('click', '#send', function (e) {
            var inputCount = $('.js-first-form input:required').length;
            var validInputs = 0;
            $('.js-first-form input:required').each(function(){
               if($(this).val() == '') {
                   return false;
               }
               else {
                   validInputs++;
               }
            });

            var email = $('.js-first-form input[type=email]').val();
            if(email != '' && !validateEmail(email) ) {
                alert('Emailová adresa není ve ve správném formátu (jmeno@domena.cz)');
                return false;
            }

            var phone = $('.js-form-phone-input').val();
            if(phone.startsWith('420') || phone.startsWith('421')) {
                alert('Překontrolujte si tel. číslo (nemělo by začínat předvolbou).')
                return false;
            }

            if(phone.length !== 11) {
                alert('Vyplňte tel. číslo ve formátu 123 456 789')
                return false;
            }

            if (inputCount == validInputs) {
                e.preventDefault();
                if(leadSent == false) {
                    var birth_date = $('#input_1').val();
                    var type_of_saving = $('#input_2').val();
                    var MP = $('#input_3').val();
                    var MPZ = $('#input_4').val();
                    var name = $('#input_5').val();
                    var surname = $('#input_6').val();
                    var email = $('#input_7').val();
                    var pre_phone = $('#frm-calculatorBasicForm-code').val();
                    var phone = $('#input_8').val();
                    var place = $('#input_9').val();
                    var form = $('#input_hidden_1').val();
                    var locationId = $('#locationId').val();

                var formData = {
                    _year: birth_date,
                    typeOfSaving: type_of_saving,
                    monthlyAllowance: MP,
                    employerMonthlyAllowance: MPZ,
                    name: name,
                    surname: surname,
                    mail: email,
                    phone: pre_phone + phone,
                    zipCode: place,
                    form: form,
                    locationId: locationId
                };

                    var ajaxURL = $(this).data('ajax');

                    jQuery.ajax({
                        type: 'POST',
                        url: ajaxURL,
                        dataType: 'json',
                        data: {formData: formData}
                    }).done(function (data) {
                        //console.log(data);
                    }).fail(function (data) {
                        //console.log(data);
                    });
                    leadSent = true;
                }

                calculateSavings(false);
                hideForm();
            }
        });

    })();

    // Calculator - life insurance

    function showForm() {
        $('.js-first-form').show();
        $('.js-second-form').hide();

        setTimeout(function(){
            $('html, body').animate({
                scrollTop: $('#form').offset().top
            }, 300);
        }, 20);
    }

    function hideForm() {
        $('.js-first-form').hide();
        $('.js-second-form').show();

        setTimeout(function(){
            $('html, body').animate({
                scrollTop: $('#form').offset().top
            }, 300);
        }, 20);
    }

    (function () {

        if($('.js-randomize-list').length) {
            var randElement = document.getElementsByClassName('c-insurance-list')[0];
            for (var i = randElement.children.length; i >= 0; i--) {
                randElement.appendChild(randElement.children[Math.random() * i | 0]);
            }
        }

        var leadSent = false;

        $(document).on('click', '.js-insurance-more-toggle', function(e){
            var ID = $(this).attr('data-for');
            e.preventDefault();
            $(this).toggleClass('c-insurance-list__more-link--hide');
            $('#' + ID).toggleClass('c-insurance-list__more-container--visible');
        });

        $(document).on('click', '.js-reset-form-life', function(e) {
            e.preventDefault();
            showForm();
        });

        $(document).on('mouseenter', '.js-life-send', function(e) {
            document.getElementById("life-company-setter").value = document.getElementById("life-company-getter").value;
        });

        $(document).on('click', '#life_send', function (e) {
            var inputCount = $('.js-first-form input:required').length;
            var validInputs = 0;
            $('.js-first-form input:required').each(function(){
                if($(this).val() == '') {
                    return false;
                }
                else {
                    validInputs++;
                }
            });

            var email = $('.js-first-form input[type=email]').val();
            if(email != '' && !validateEmail(email) ) {
                alert('Emailová adresa není ve ve správném formátu (jmeno@domena.cz)');
                return false;
            }

            var phone = $('.js-form-phone-input').val();
            if(phone.startsWith('420') || phone.startsWith('421')) {
                alert('Překontrolujte si tel. číslo (nemělo by začínat předvolbou).')
                return false;
            }

            if(phone.length !== 11) {
                alert('Vyplňte tel. číslo ve formátu 123 456 789')
                return false;
            }

            if (inputCount == validInputs) {
                hideForm();
                e.preventDefault();
                if(leadSent == false) {
                    var birth_date = $('#input_1').val();
                    var occupation = $('#input_2').val();
                    var income = $('#input_3').val();
                    var name = $('#input_4').val();
                    var surname = $('#input_5').val();
                    var email = $('#input_6').val();
                    var pre_phone = $('#frm-calculatorhBasicForm-code').val();
                    var phone = $('#input_7').val();
                    var place = $('#input_8').val();
                    var form = $('#input_hidden_1').val();
                    var locationId = $('#locationId').val();

                    var formData = {
                        _year: birth_date,
                        occupation: occupation,
                        income: income,
                        name: name,
                        surname: surname,
                        mail: email,
                        phone: pre_phone + phone,
                        zipCode: place,
                        form: form,
                        locationId: locationId
                    };

                    var ajaxURL = $(this).data('ajax');

                    jQuery.ajax({
                        type: 'POST',
                        url: ajaxURL,
                        dataType: 'json',
                        data: {formData: formData}
                    }).done(function (data) {
                        //console.log(data);
                    }).fail(function (data) {
                        //console.log(data);
                    });
                    leadSent = true;
                }
            }
        });
    })();

    // Calculator - Hypotéka

    (function () {

        var leadSent = false;

        $(document).on('mouseenter', '.js-hypo-send', function() {
            var company = $(this).siblings('.hypo-company-getter').val();
            $('#hypo-company-setter').val(company);
        });

        $(document).on('click', '.js-reset-form-hypo', function(e) {
            e.preventDefault();
            showForm();
        });

        function calculateHypo(update) {
            var property_value = $('#input_1').val();
            var amount = $('#input_2').val();
            var fixation = $('#input_3').val();
            var time = $('#input_4').val();
            var interest = 0;
            var monthlyFee = 0;
            var totalAmount = 0;

            if(update == true) {
                property_value = $('#input_10').val();
                amount = $('#input_11').val();
                fixation = $('#input_12').val();
                time = $('#input_13').val();
                $('#input_1').val($('#input_10').val());
                $('#input_2').val($('#input_11').val());
                $('#input_3').val($('#input_12').val());
                $('#input_4').val($('#input_13').val());
            }

            else {
                $('#input_10').val($('#input_1').val());
                $('#input_11').val($('#input_2').val());
                $('#input_12').val($('#input_3').val());
                $('#input_13').val($('#input_4').val());
            }

            time = parseInt(time);
            amount = parseInt(amount.replace(/\s/g, ''));
            property_value = parseInt(property_value.replace(/\s/g, ''));

            var LTV = (amount / property_value) * 100;

            var numbersArray = [];

            $('.js-hypo-fee-' + fixation).each(function(){
                var min = $(this).find('.js-hypo-fee-min').text();
                var max = $(this).find('.js-hypo-fee-max').text();

                var min = parseInt(min);
                var max = parseInt(max);

                if (!isNaN(max)) {
                    numbersArray.push(max);
                }

                // Show only amount - relevant items

                $(this).closest('.js-list-item').hide();
                var numbers = $.map(numbersArray, function (value) {
                    return parseFloat(value);
                });
                var highestNumber = Math.max.apply(null, numbers);
                if(amount <= highestNumber) {
                    $(this).closest('.js-list-item').show();
                }

                if( amount >= min && amount <= max ) {
                    var n = time * 12;

                    $(this).find('.js-hypo-fee').each(function(){
                        if(LTV <= $(this).attr('data-fee')) {
                            var interest = parseFloat($(this).text()) / 100;
                            $(this).closest('.js-list-item').show();
                            if(interest == 0 || isNaN(interest)) {
                                $(this).closest('.js-list-item').hide();
                            }
                            r = interest / 12;
                            monthlyFee = parseInt(amount * ((r * Math.pow(1 + r, n)) / ((Math.pow(1 + r, n)) - 1)));
                            totalAmount = parseInt(monthlyFee * time * 12);

                            monthlyFee = spacedNumber(monthlyFee);
                            totalAmount = spacedNumber(totalAmount);

                            var interestPrint = parseFloat(interest * 100);
                            interestPrint = interestPrint.toFixed(2).replace('.00', '');
                            interestPrint = interestPrint.replace(/(\d)0+/g, '$1');

                            $(this).closest('.js-main').find('.js-fee, .js-monthly, .js-total').remove();
                            $('<div class="c-insurance-list__total js-total" title="Celkem zaplatíte">' + totalAmount + ' Kč</div>').insertAfter($(this).closest('.js-interest'));
                            $('<div class="c-insurance-list__monthly js-monthly" title="Měsíční splátka">' + monthlyFee + ' Kč</div>').insertAfter($(this).closest('.js-interest'));
                            $('<div class="c-insurance-list__interest js-fee" title="Úroková sazba">' + interestPrint + ' %</div>').insertAfter($(this).closest('.js-interest'));
                            return false;
                        }
                    });
                }
            }); 

            $('.js-total').each(function(){
                if($(this).text().includes('NaN')) {
                    $(this).closest('.js-list-item').hide();
                }
            });
        }

        $(document).on('change', '.js-hypo-update', function(){
            calculateHypo(true);
        });

        $(document).on('change', '.js-hypo-cost, .js-hypo-amount', function(){
            var cost = parseInt($('.js-hypo-cost').val().replaceAll(' ', ''));
            var amount = parseInt($('.js-hypo-amount').val().replaceAll(' ', ''));

            if(amount >= cost) {
                $('.js-hypo-amount').val($('.js-hypo-cost').val())
            }
        });

        $(document).on('click', '#calculateHypo', function (e) {

            var inputCount = $('.js-first-form input:required').length;
            var validInputs = 0;
            $('.js-first-form input:required').each(function(){
                if($(this).val() == '') {
                    return false;
                }
                else {
                    validInputs++;
                }
            });

            var email = $('.js-email').val();
            if(email != '' && !validateEmail(email) ) {
                alert('Emailová adresa není ve ve správném formátu (jmeno@domena.cz)');
                return false;
            }

            var phone = $('.js-form-phone-input').val();
            if(phone.startsWith('420') || phone.startsWith('421')) {
                alert('Překontrolujte si tel. číslo (nemělo by začínat předvolbou).')
                return false;
            }

            if(phone.length !== 11) {
                alert('Vyplňte tel. číslo ve formátu 123 456 789')
                return false;
            }

            calculateHypo(false);

            if (inputCount == validInputs) {
                hideForm();
                e.preventDefault();
                if(leadSent == false) {
                    var property_value = $('#input_1').val().replaceAll(' ', '');
                    var amount = $('#input_2').val().replaceAll(' ', '');
                    var fixation = $('#input_3').val();
                    var period = $('#input_4').val();
                    var name = $('#input_5').val();
                    var surname = $('#input_6').val();
                    var pre_phone = $('#frm-calculatorBasicForm-code').val();
                    var phone = $('#input_8').val().replaceAll(' ', '');
                    var email = $('#input_7').val();
                    var zipCode = $('#input_9').val();
                    var form = $('#input_hidden_1').val();
                    var locationId = $('#locationId').val();

                    var formData = {
                        purpose: 'purchase',
                        propertyValue: property_value,
                        loanAmount: amount,
                        fixationLength: fixation,
                        maturityLength: period,
                        name: name,
                        surname: surname,
                        phone: pre_phone + phone,
                        phoneVerified: false,
                        mail: email,
                        zipCode: zipCode,
                        form: form,
                        locationId: locationId
                    }

                    var ajaxURL = $(this).data('ajax');

                    jQuery.ajax({
                        type: 'POST',
                        url: ajaxURL,
                        dataType: 'json',
                        data: {formData: formData}
                    }).done(function (data) {
                        //console.log(data);
                    }).fail(function (data) {
                        //console.log(data);
                    });
                    leadSent = true;
                }
            }
        });
    })();

    // Calculator - Investice

    (function () {
        var leadSent = false;
        function calculateInvestments(update) {
            var currentYear = parseInt(new Date().getFullYear());
            var years = [];

            hideForm();

            var JI = $('#input_1').val();
            var PMI = $('#input_2').val();
            var DI = $('#input_3').val();
            var ZH = $('#input_4').val();


            if(update == true) {
                JI = $('#input_10').val();
                PMI = $('#input_11').val();
                DI = $('#input_12').val();
                ZH = $('#input_13').val();
                $('#input_1').val($('#input_10').val());
                $('#input_2').val($('#input_11').val());
                $('#input_3').val($('#input_12').val());
                $('#input_4').val($('#input_13').val());
            }

            else {
                $('#input_10').val($('#input_1').val());
                $('#input_11').val($('#input_2').val());
                $('#input_12').val($('#input_3').val());
                $('#input_13').val($('#input_4').val());
            }

            JI = parseInt(JI.replace(/\s/g, ''));
            PMI = parseInt(PMI.replace(/\s/g, ''));

            var invested = JI + (PMI * (DI * 12));

            var ZPI = parseInt((PMI * (((Math.pow((1 + (ZH / 12)), DI * 12)) - 1) / (ZH / 12))) - (PMI * (DI * 12)));
            var ZJI = parseInt((JI * ((Math.pow((1 + (ZH / 12)), DI * 12)))) - JI);

            var finalCalculation = ZPI + ZJI;

            var investedYearly = [];
            var evaluationYearly = [];

            for (i = 1; i <= DI; i++) {
                years.push(currentYear++);
                investedYearly.push(parseInt(JI + (PMI * (i * 12))));
                evaluationYearly.push(parseInt((PMI * (((Math.pow((1 + (ZH / 12)), i * 12)) - 1) / (ZH / 12))) - (PMI * (i * 12))) + ((JI * ((Math.pow((1 + (ZH / 12)), i * 12)))) - JI));
            }

            investedYearly.map(Number);
            evaluationYearly.map(Number);

            var graphicTotal = invested + finalCalculation;

            $('.js-legend-invested').html(spacedNumber(invested) + ' Kč');
            $('.js-legend-ZPI').html(spacedNumber(ZPI) + ' Kč');
            $('.js-legend-ZJI').html(spacedNumber(ZJI) + ' Kč');
            $('.js-legend-graphic').html(spacedNumber(graphicTotal) + ' Kč');
            $('.js-legend-total').html(spacedNumber(finalCalculation) + ' Kč');

            if (update == false) {
                ctx_donut = new Chart(document.getElementById('chart_donut'), {
                    type: 'doughnut',
                    options: {
                        animation: true,
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        }
                    },
                    data: {
                        labels: ['Zainvestováno', 'Celkové možné zhodnocení za 10 let'],
                        datasets: [{
                            data: [invested, finalCalculation],
                            backgroundColor: ['#5D7AE2', '#05AD71'],
                            borderWidth: 0
                        }]
                    }
                });

                ctx_bar = new Chart(document.getElementById('chart_bar'), {
                    type: 'bar',
                    options: {
                        animation: true,
                        responsive: true,
                        scales: {
                            x: {
                                stacked: true,
                            },
                            y: {
                                stacked: true
                            }
                        },
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        }
                    },
                    data: {
                        labels: years,
                        datasets: [
                            {
                                label: 'Investováno ročně',
                                data: investedYearly,
                                backgroundColor: '#5D7AE2'
                            },
                            {
                                label: 'Zhodnocení ročně',
                                data: evaluationYearly,
                                backgroundColor: '#05AD71'
                            }
                        ]
                    }
                });
            }

            else {
                ctx_donut.data = {
                    labels: ['Naspořeno a zhodnoceno', 'Příspěvek zaměstnavatele', 'Státní příspěvěk'],
                    datasets: [{
                        data: [invested, finalCalculation],
                        backgroundColor: ['#5D7AE2', '#05AD71'],
                        borderWidth: 0
                    }]
                }
                ctx_bar.data = {
                    labels: years,
                    datasets: [
                        {
                            label: 'Investováno ročně',
                            data: investedYearly,
                            backgroundColor: '#5D7AE2'
                        },
                        {
                            label: 'Zhodnocení ročně',
                            data: evaluationYearly,
                            backgroundColor: '#05AD71'
                        }
                    ]
                }
                ctx_donut.update();
                ctx_bar.update();
            }

            $('.js-graph-center').addClass('c-calculator__graph-center-container--visible');
        }

        $(document).on('click', '#calculateInvestments', function (e) {
            var inputCount = $('.js-first-form input:required').length;
            var validInputs = 0;
            $('.js-first-form input:required').each(function(){
                if($(this).val() == '') {
                    return false;
                }
                else {
                    validInputs++;
                }
            });

            var email = $('.js-first-form input[type=email]').val();
            if(email != '' && !validateEmail(email) ) {
                alert('Emailová adresa není ve ve správném formátu (jmeno@domena.cz)');
                return false;
            }

            var phone = $('.js-form-phone-input').val();
            if(phone.startsWith('420') || phone.startsWith('421')) {
                alert('Překontrolujte si tel. číslo (nemělo by začínat předvolbou).')
                return false;
            }

            if(phone.length !== 11) {
                alert('Vyplňte tel. číslo ve formátu 123 456 789')
                return false;
            }

            if (inputCount == validInputs) {
                e.preventDefault();
                if(leadSent == false) {
                    var JI = $('#input_1').val();
                    var PMI = $('#input_2').val();
                    var DI = $('#input_3').val();
                    var TI = $('#input_4').val();
                    var name = $('#input_5').val();
                    var surname = $('#input_6').val();
                    var email = $('#input_7').val();
                    var pre_phone = $('#frm-calculatorBasicForm-code').val();
                    var phone = $('#input_8').val();
                    var place = $('#input_9').val();
                    var form = $('#input_hidden_1').val();
                    var locationId = $('#locationId').val();

                    var formData = {
                        investmentValue: JI,
                        monthlyInvestment: PMI,
                        investmentLength: DI,
                        annualInterest: TI,
                        name: name,
                        surname: surname,
                        mail: email,
                        phone: pre_phone + phone,
                        zipCode: place,
                        type: 'investment',
                        form: form,
                        locationId: locationId
                    };

                    var ajaxURL = $(this).data('ajax');

                    jQuery.ajax({
                        type: 'POST',
                        url: ajaxURL,
                        dataType: 'json',
                        data: {formData: formData}
                    }).done(function (data) {
                        //console.log(data);
                    }).fail(function (data) {
                        //console.log(data);
                    });
                    leadSent = true;
                }

                calculateInvestments(false);
                hideForm();
            }
        });

        $(document).on('click', '.js-reset-invest-form', function(e){
            e.preventDefault();
            showForm();
            ctx_donut.destroy();
            ctx_bar.destroy();

            $('.js-graph-center').removeClass('c-calculator__graph-center-container--visible');
        });

        $(document).on('change', '.js-investment-calculator .js-invest-update', function(){
            calculateInvestments(true);
        });

        $(document).on('click', '.js-investment-calculator .o-number__button--up, .js-investment-calculator .o-number__button--down', function(){
            calculateInvestments(true);
        });

    })();

    // Calculator - III. pilíř dúchodového pojištění

    (function () {
        var leadSent = false;
        var employeeThreshold = 48000;
        var employerThreshold = 50000;

        function checkPillar() {

            var DPS_employee = $('#input_1').val();
            var DPS_employer = $('#input_2').val();
            var DIP_employee = $('#input_3').val();
            var DIP_employer = $('#input_4').val();
            var IZP_employee = $('#input_5').val();
            var IZP_employer = $('#input_6').val();
            DPS_employee = parseInt(DPS_employee.replace(/\s/g, ''));
            DPS_employer = parseInt(DPS_employer.replace(/\s/g, ''));
            DIP_employee = parseInt(DIP_employee.replace(/\s/g, ''));
            DIP_employer = parseInt(DIP_employer.replace(/\s/g, ''));
            IZP_employee = parseInt(IZP_employee.replace(/\s/g, ''));
            IZP_employer = parseInt(IZP_employer.replace(/\s/g, ''));

            var DPS_employee_yearly = DPS_employee * 12;
            var DPS_employer_yearly = DPS_employer * 12;
            var DIP_employee_yearly = DIP_employee * 12;
            var DIP_employer_yearly = DIP_employer * 12;
            var IZP_employee_yearly = IZP_employee * 12;
            var IZP_employer_yearly = IZP_employer * 12;

            if (DPS_employee <= 1700) {
                var employeeTotal = DIP_employee_yearly + IZP_employee_yearly;
            }
            else {
                var DPS_employee_yearly_taxes = (DPS_employee - 1700) * 12;
                var employeeTotal = DPS_employee_yearly_taxes + DIP_employee_yearly + IZP_employee_yearly;
            }

            var employerTotal = DPS_employer_yearly + DIP_employer_yearly + IZP_employer_yearly;

            if (employeeTotal >= employeeThreshold) {
                $('.js-pillar-number-employee').find('.o-number__button--up').css('visibility', 'hidden');
            } else {
                $('.js-pillar-number-employee').find('.o-number__button--up').css('visibility', 'visible');
            }

            if (employerTotal >= (employerThreshold - 800)) {
                $('.js-pillar-number-employer').find('.o-number__button--up').css('visibility', 'hidden');
            } else {
                $('.js-pillar-number-employer').find('.o-number__button--up').css('visibility', 'visible');
            }
        }

        function calculatePillar(update) {

            var DPS_employee = $('#input_1').val();
            var DPS_employer = $('#input_2').val();

            var DIP_employee = $('#input_3').val();
            var DIP_employer = $('#input_4').val();

            var IZP_employee = $('#input_5').val();
            var IZP_employer = $('#input_6').val();


            if(update == true) {
                DPS_employee = $('#input_11').val();
                DPS_employer = $('#input_12').val();
                DIP_employee = $('#input_13').val();
                DIP_employer = $('#input_14').val();
                IZP_employee = $('#input_15').val();
                IZP_employer = $('#input_16').val();
                $('#input_1').val($('#input_11').val());
                $('#input_2').val($('#input_12').val());
                $('#input_3').val($('#input_13').val());
                $('#input_4').val($('#input_14').val());
                $('#input_5').val($('#input_15').val());
                $('#input_6').val($('#input_16').val());
            }

            else {
                $('#input_11').val($('#input_1').val());
                $('#input_12').val($('#input_2').val());
                $('#input_13').val($('#input_3').val());
                $('#input_14').val($('#input_4').val());
                $('#input_15').val($('#input_5').val());
                $('#input_16').val($('#input_6').val());
            }

            DPS_employee = parseInt(DPS_employee.replace(/\s/g, ''));
            DPS_employer = parseInt(DPS_employer.replace(/\s/g, ''));

            DIP_employee = parseInt(DIP_employee.replace(/\s/g, ''));
            DIP_employer = parseInt(DIP_employer.replace(/\s/g, ''));

            IZP_employee = parseInt(IZP_employee.replace(/\s/g, ''));
            IZP_employer = parseInt(IZP_employer.replace(/\s/g, ''));

            var DPS_employee_yearly = DPS_employee * 12;
            var DPS_employer_yearly = DPS_employer * 12;

            var DIP_employee_yearly = DIP_employee * 12;
            var DIP_employer_yearly = DIP_employer * 12;

            var IZP_employee_yearly = IZP_employee * 12;
            var IZP_employer_yearly = IZP_employer * 12;

            var DPS = parseInt(DPS_employee + DPS_employer) * 12;
            var DIP = parseInt(DIP_employee + DIP_employer) * 12;
            var IZP = parseInt(IZP_employee + IZP_employer) * 12;

            var total = DPS + DIP + IZP;

            $('.js-pillar-DPS-total').html(spacedNumber(DPS) + ' Kč');
            $('.js-pillar-DPS-employee').html(spacedNumber(DPS_employee_yearly) + ' Kč');
            $('.js-pillar-DPS-employer').html(spacedNumber(DPS_employer_yearly) + ' Kč');

            $('.js-pillar-DIP-total').html(spacedNumber(DIP) + ' Kč');
            $('.js-pillar-DIP-employee').html(spacedNumber(DIP_employee_yearly) + ' Kč');
            $('.js-pillar-DIP-employer').html(spacedNumber(DIP_employer_yearly) + ' Kč');

            $('.js-pillar-IZP-total').html(spacedNumber(IZP) + ' Kč');
            $('.js-pillar-IZP-employee').html(spacedNumber(IZP_employee_yearly) + ' Kč');
            $('.js-pillar-IZP-employer').html(spacedNumber(IZP_employer_yearly) + ' Kč');

            if (DPS_employee <= 1700) {
                var employeeTotal = DIP_employee_yearly + IZP_employee_yearly;
            }
            else {
                var DPS_employee_yearly_taxes = (DPS_employee - 1700) * 12;
                var employeeTotal = DPS_employee_yearly_taxes + DIP_employee_yearly + IZP_employee_yearly;
            }

            var employerTotal = DPS_employer_yearly + DIP_employer_yearly + IZP_employer_yearly;

            var employeeDifference = employeeThreshold - employeeTotal;
            var employerDifference = employerThreshold - employerTotal;

            $('.js-employee-total').html(spacedNumber(employeeTotal) + ' Kč');
            $('.js-employer-total').html(spacedNumber(employerTotal) + ' Kč');
            $('.js-employee-difference').html(spacedNumber(employeeDifference) + ' Kč');
            $('.js-employer-difference').html(spacedNumber(employerDifference) + ' Kč');

            if (employeeTotal >= employeeThreshold) {
                $('.js-employee-difference').html('0 Kč');
                $('.js-pillar-total').html('0 Kč');
                var differencePositive = false;
                $('.js-difference-legend').hide();
                $('.js-pillar-update-employee').find('.o-number__button--up').css('visibility', 'hidden');
            }

            else {
                var differencePositive = true;
                $('.js-pillar-total').html(spacedNumber(employeeDifference) + ' Kč');
                $('.js-difference-legend').show();
                $('.js-pillar-update-employee').find('.o-number__button--up').css('visibility', 'visible');
            }

            if (employerTotal >= employerThreshold) {
                $('.js-employer-difference').html('0 Kč');
            }

            if (employerTotal >= (employerThreshold - 800)) {
                $('.js-pillar-update-employer').find('.o-number__button--up').css('visibility', 'hidden');
            }

            else {
                $('.js-pillar-update-employer').find('.o-number__button--up').css('visibility', 'visible');
            }

            /*

            var threshold = employeeThreshold + employerThreshold;
            var difference = threshold - total;

            if (total >= threshold) {
                var differencePositive = false;
                $('.js-difference-legend').hide();
            }
            else {
                var differencePositive = true;
                $('.js-difference-legend').show();
            }

            */

            if (update == false) {
                hideForm();

                ctx_donut = new Chart(document.getElementById('chart_donut'), {
                    type: 'doughnut',
                    options: {
                        animation: true,
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        }
                    },
                    data: {
                        labels: ['Doplňkové penzijní spoření (DPS)', 'Dlouhodobý investiční produkt (DIP)','Investiční životní pojištění (IŽP)'],
                        datasets: [{
                            data: differencePositive ? [employeeTotal, employeeDifference] : [employeeTotal],
                            backgroundColor: differencePositive ? ['#7bdcb5', '#ea7e65'] : ['#7bdcb5'],
                            borderWidth: 0
                        }]
                    }
                });
            }

            else {
                ctx_donut.data = {
                    labels: ['Doplňkové penzijní spoření (DPS)', 'Dlouhodobý investiční produkt (DIP)','Investiční životní pojištění (IŽP)'],
                    datasets: [{
                        data: differencePositive ? [employeeTotal, employeeDifference] : [employeeTotal],
                        backgroundColor: differencePositive ? ['#7bdcb5', '#ea7e65'] : ['#7bdcb5'],
                        borderWidth: 0
                    }]
                }
                ctx_donut.update();
            }

            $('.js-graph-center').addClass('c-calculator__graph-center-container--visible');
        }

        $(document).on('click', '#calculatePillar', function (e) {
            var inputCount = $('.js-first-form input:required').length;
            var validInputs = 0;
            $('.js-first-form input:required').each(function(){
                if($(this).val() == '') {
                    return false;
                }
                else {
                    validInputs++;
                }
            });

            var email = $('.js-first-form input[type=email]').val();
            if(email != '' && !validateEmail(email) ) {
                alert('Emailová adresa není ve ve správném formátu (jmeno@domena.cz)');
                return false;
            }

            var phone = $('.js-form-phone-input').val();
            if(phone.startsWith('420') || phone.startsWith('421')) {
                alert('Překontrolujte si tel. číslo (nemělo by začínat předvolbou).')
                return false;
            }

            if(phone.length !== 11) {
                alert('Vyplňte tel. číslo ve formátu 123 456 789')
                return false;
            }

            if (inputCount == validInputs) {
                e.preventDefault();
                if(leadSent == false) {
                    var DPS_employee = $('#input_1').val();
                    var DPS_employer = $('#input_2').val();
                    var DIP_employee = $('#input_3').val();
                    var DIP_employer = $('#input_4').val();
                    var IZP_employee = $('#input_5').val();
                    var IZP_employer = $('#input_6').val();
                    var name = $('#input_7').val();
                    var surname = $('#input_8').val();
                    var pre_phone = $('#frm-calculatorBasicForm-code').val();
                    var phone = $('#input_9').val();
                    var mail = $('#input_10').val();
                    var zipCode = $('#zipCode').val();
                    var form = $('#input_hidden_1').val();
                    var locationId = $('#locationId').val();

                    var formData = {
                        monthlyAllowance_DPS: DPS_employee,
                        employerMonthlyAllowance_DPS: DPS_employer,
                        monthlyAllowance_DIP: DIP_employee,
                        employerMonthlyAllowance_DIP: DIP_employer,
                        monthlyAllowance_IZP: IZP_employee,
                        employerMonthlyAllowance_IZP: IZP_employer,
                        name: name,
                        surname: surname,
                        email: mail,
                        phone: pre_phone + phone,
                        zipCode: zipCode,
                        type: 'pensionSavings',
                        form: form,
                        locationId: locationId
                    };

                    var ajaxURL = $(this).data('ajax');

                    jQuery.ajax({
                        type: 'POST',
                        url: ajaxURL,
                        dataType: 'json',
                        data: {formData: formData}
                    }).done(function (data) {
                        //console.log(data);
                    }).fail(function (data) {
                        //console.log(data);
                    });
                    leadSent = true;
                }

                calculatePillar(false);
                hideForm();
            }
        });

        $(document).on('click', '.js-reset-pillar-form', function(e){
            e.preventDefault();
            showForm();
            ctx_donut.destroy();

            $('.js-graph-center').removeClass('c-calculator__graph-center-container--visible');
        });

        $(document).on('change', '.js-pillar .js-pillar-update', function(){
            calculatePillar(true);
        });

        $(document).on('click', '.js-pillar .o-number__button--up, .js-pillar .o-number__button--down', function(){
            calculatePillar(true);
        });

        $(document).on('change', '.js-pillar-first-form .js-pillar-input', function(){
            checkPillar();
        });

        $(document).on('click', '.js-pillar-first-form .o-number__button--up, .js-pillar-first-form .o-number__button--down', function(){
            checkPillar();
        });

    })();

});

